import { render, staticRenderFns } from "./milestone_popover.vue.js?vue&type=template&id=5a8e9595&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./milestone_popover.vue?vue&type=template&id=5a8e9595&vue3"
import script from "./milestone_popover.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./milestone_popover.vue?vue&type=script&lang=js&vue3"
export * from "./milestone_popover.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./milestone_popover.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports